import { Paper } from "@material-ui/core";

import React, { Component } from "react";
import { withRouter } from "react-router";
import Config from "../../config";
import { withAllContexts } from "../../HOCs";

class Tutorials extends Component {
  render() {
    return (
      <>
        <Paper
          style={{
            width: "100%",
            height: "100%",
            // backgroundColor: "#F3F4F7",
            padding: "8px",
          }}
          elevation={0}
        >
          <Paper
            style={{
              width: "100%",
              height: "100%",
              // padding: "20px",
            }}
            elevation={0}
          >
              <iframe
              title="Task And Document"
              src={Config.tutorials}
              style={{
                width: "100%",
                height: "100%",
                outline: "none",
                border: "none",
              }}
            ></iframe>
          </Paper>
        </Paper>
      </>
    );
  }
}

export default withRouter(withAllContexts(Tutorials));
